import { createSlice } from "@reduxjs/toolkit";

import { NAVIGATION_STATE } from "../../constants";

import { NavigationState } from "../../types";

import { setAutos } from "./setAutos";
import { setAutosLoadingStatus } from "./setAutosLoadingStatus";

import { setHistory } from "./setHistory";
import { resetHistory } from "./resetHistory";
import { setHistoryLoadingStatus } from "./setHistoryLoadingStatus";
import {
  setClientFuelEventLoadingStatus,
  setClientFuelEventsData,
} from "./setClientFuelEventsData";
import { resetClientEventHistory } from "./resetClientEventHistory";
import {
  setClientRoadEventLoadingStatus,
  setClientRoadEventsData,
} from "./setClientRoadEventsData";
import {
  setClientServiceEventData,
  setClientServiceEventLoadingStatus,
} from "./setClientServiceEventData";
import { addClientEventHistoryFilter } from "./addClientEventHistoryFilter";
import { deleteClientEventHistoryFilter } from "./deleteClientEventHistoryFilter";
import { resetClientEventHistoryFilter } from "./resetClientEventHistoryFilter";

const initialState: NavigationState = {
  autos: {},
  history: {},
  clientEvents: {
    fuel: {},
    road: {},
    service: {},
  },
  clientEventsPathFilters: [],
};

export const navigationSlice = createSlice({
  name: NAVIGATION_STATE,
  initialState,
  reducers: {
    setAutos,
    setAutosLoadingStatus,

    setHistory,
    resetHistory,
    setHistoryLoadingStatus,

    setClientFuelEventsData,
    setClientFuelEventLoadingStatus,

    setClientRoadEventsData,
    setClientRoadEventLoadingStatus,

    setClientServiceEventData,
    setClientServiceEventLoadingStatus,

    resetClientEventHistory,

    addClientEventHistoryFilter,
    deleteClientEventHistoryFilter,
    resetClientEventHistoryFilter,
  },
});

export const navigationActions = navigationSlice.actions;
export const navigationReducer = navigationSlice.reducer;
